export default __webpack_public_path__ + "static/talcumbezel-144a897c82cfa2a55e4ec08b11445ce6.png";